import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Accordion/accordion';
import { AccordionContext } from './AccordionContext';
export var Accordion = function Accordion(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? '' : _a$ariaLabel,
      _a$headingLevel = _a.headingLevel,
      headingLevel = _a$headingLevel === void 0 ? 'h3' : _a$headingLevel,
      _a$asDefinitionList = _a.asDefinitionList,
      asDefinitionList = _a$asDefinitionList === void 0 ? true : _a$asDefinitionList,
      props = __rest(_a, ["children", "className", 'aria-label', "headingLevel", "asDefinitionList"]);

  var AccordionList = asDefinitionList ? 'dl' : 'div';
  return React.createElement(AccordionList, Object.assign({
    className: css(styles.accordion, className),
    "aria-label": ariaLabel
  }, props), React.createElement(AccordionContext.Provider, {
    value: {
      ContentContainer: asDefinitionList ? 'dd' : 'div',
      ToggleContainer: asDefinitionList ? 'dt' : headingLevel
    }
  }, children));
};